import { createSlice } from "@reduxjs/toolkit";
import {
  getAllActiveWebBranches,
  insertLead,
  emailSubscribe,
} from "./services/contact.services";
import { IContactState } from "./contactModel";

const initialState: IContactState = {
  loading: false,
  InquiryLoading: false,
  newsletterLoading: false,
  error: "",
  WebBranchList: [],
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(insertLead.pending, (state) => {
      state.InquiryLoading = true;
      state.error = "";
    });
    builder.addCase(insertLead.fulfilled, (state) => {
      state.InquiryLoading = false;
    });
    builder.addCase(insertLead.rejected, (state, action) => {
      state.InquiryLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveWebBranches.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllActiveWebBranches.fulfilled, (state, action) => {
      state.loading = false;
      state.WebBranchList = action.payload || [];
    });
    builder.addCase(getAllActiveWebBranches.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WebBranchList = [];
    });

    builder.addCase(emailSubscribe.pending, (state) => {
      state.newsletterLoading = true;
      state.error = "";
    });
    builder.addCase(emailSubscribe.fulfilled, (state) => {
      state.newsletterLoading = false;
    });
    builder.addCase(emailSubscribe.rejected, (state, action) => {
      state.newsletterLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default contactSlice.reducer;
